import { LendingAviation } from '@/types/lending';
import { SVSummaryCard } from '../core';
import { formatDateTimeFromUTC } from '@/utils/date';
import { formatCurrency } from '@/utils/currency';

type LendingAviationDetailsProps = {
  loanRequest: LendingAviation;
};

export default function LendingAviationDetails({
  loanRequest,
}: LendingAviationDetailsProps) {
  const {
    customerEmail,
    customerName,
    customerPhone,
    submittedAt,
    aircraftCondition,
    aircraftDetails,
    requestedLoanAmount,
    downPaymentAmount,
    grossMonthlyIncome,
    willBeOwnedByHoldingCompany,
  } = loanRequest;

  return (
    <SVSummaryCard
      label="Aviation Loan Request Details"
      items={[
        { label: 'Name', text: customerName },
        { label: 'Email', text: customerEmail },
        { label: 'Phone', text: customerPhone },
        {
          label: 'Submitted At',
          text: formatDateTimeFromUTC(submittedAt),
        },
        { label: 'Aircraft Condition', text: aircraftCondition },
        { label: 'Aircraft Details', text: aircraftDetails },
        {
          label: 'Request Loan Amount',
          text: formatCurrency({ amount: requestedLoanAmount }),
        },
        {
          label: 'Downpayment Amount',
          text: formatCurrency({ amount: downPaymentAmount }),
        },
        {
          label: 'Gross Monthly Income',
          text: formatCurrency({ amount: grossMonthlyIncome }),
        },
        {
          label: 'Will Be Owned By Holding Company',
          text: willBeOwnedByHoldingCompany ? 'True' : 'False',
        },
      ]}
    />
  );
}
